import store from '../../store';
import {LOGIN_SSO, LOGOUT} from '../../store/modules/auth';

const AuthHandler = {
    install(Vue, options) {
        Vue.prototype.$auth = {
            /**
             * Get the currently signed in user.
             * @returns {*} or null
             */
            currentUser() {
                return store.getters.currentUser;
            },

            /**
             * Sign in a single sign-on token
             * @param {String} sso_token
             * @returns {Promise}
             */
            signInWithToken(sso_token) {
                return store.dispatch(LOGIN_SSO, sso_token);
            },

            /**
             * Sign out the currently signed in user.
             * @returns {Promise}
             */
            signOut() {
                return store.dispatch(LOGOUT);
            }
        };
    }
};

export default AuthHandler;



// WEBPACK FOOTER //
// ./src/components/auth/AuthHandler.js